import { START, SUCCESS, ERROR } from '../../../../constants/action-postfix'
import {
  EDU_COMMISSIONS_LIST_REQUEST,
  EDU_COMMISSIONS_GET_REQUEST,
} from '../eduCommissionsActionTypes'

const START_ACTIONS = [
  EDU_COMMISSIONS_LIST_REQUEST,
  EDU_COMMISSIONS_GET_REQUEST,
].map(type => `${type}${START}`)

const DONE_ACTIONS = [
  EDU_COMMISSIONS_LIST_REQUEST,
  EDU_COMMISSIONS_GET_REQUEST,
].flatMap(type => [`${type}${SUCCESS}`, `${type}${ERROR}`])

const initialState = false

export const eduCommissionsLoaderReducer = (state = initialState, action) => {
  if (START_ACTIONS.includes(action.type)) return true
  if (DONE_ACTIONS.includes(action.type))  return false
  return state
}
